// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__21pzt","buttons":"SendReceipts_buttons__3jf4k","email":"SendReceipts_email__3CDYP","bookApptTitle":"SendReceipts_bookApptTitle__2QQ9Y"};